import React from 'react'
import giftcard from "../../Images/gift-icon.png"
import { Link } from 'react-router-dom';

import {
    Accordion,
    AccordionItem,
    AccordionItemHeading,
    AccordionItemButton,
    AccordionItemPanel,
} from 'react-accessible-accordion';

// Demo styles, see 'Styles' section below for some notes on use.
import 'react-accessible-accordion/dist/fancy-example.css';
import TermsConditions from './TermsConditions';

function RewardsAbout() {

    return (
        <>
            <section className='rewardsAbout_page'>
                <div className='cust_container'>
                    <div className="top_area">
                        <Link to="/reward" className="backbtn"> <i className="fa-solid fa-arrow-left-long" /></Link>
                        <h4 className="heading">About</h4>
                        <Link to="/my-wallet" className="icon">
                            <img
                                src={giftcard}
                                className="img-fluid"
                                alt="....."
                            />
                        </Link>
                    </div>


                    {/****accordion start***/}
                    <Accordion>

                        {/**About***/}
                        <AccordionItem>
                            <AccordionItemHeading>
                                <AccordionItemButton>
                                    <p>About Neoo search rewards</p>
                                </AccordionItemButton>
                            </AccordionItemHeading>
                            <AccordionItemPanel>
                                <p><strong>Earn with Neoo Search Business Rewards</strong></p>
                                <p>
                                    Unlock exciting opportunities with Neoo Search Business Rewards!
                                </p>
                                <p>
                                    When you purchase a Neoo Search Business Pack, you start earning reward points for every action you take — from adding new members and engaging in others profile activities to redeeming exclusive offers. The more you connect and grow, the more rewards you earn.
                                </p>
                                <p>Boost your business visibility, reach more customers, and get recognized for being an active part of the Neoo Search community.</p>
                            </AccordionItemPanel>
                        </AccordionItem>

                        {/**Privacy Policy***/}
                        {/* <AccordionItem>
                            <AccordionItemHeading>
                                <AccordionItemButton>
                                    <p>Privacy Policy</p>
                                </AccordionItemButton>
                            </AccordionItemHeading>
                            <AccordionItemPanel>
                                <p>
                                    Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                                    Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,
                                    when an unknown printer took a galley of type and scrambled it to make a type
                                    specimen book. It has survived not only five centuries, but also the leap into
                                    electronic typesetting, remaining essentially unchanged. It was popularised
                                    in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages,
                                    and more recently with desktop publishing software like Aldus PageMaker including
                                    versions of Lorem Ipsum.
                                </p>
                                <p>
                                    Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                                    Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,
                                    when an unknown printer took a galley of type and scrambled it to make a type
                                    specimen book. It has survived not only five centuries, but also the leap into
                                    electronic typesetting, remaining essentially unchanged. It was popularised
                                    in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages,
                                    and more recently with desktop publishing software like Aldus PageMaker including
                                    versions of Lorem Ipsum.
                                </p>
                            </AccordionItemPanel>
                        </AccordionItem> */}

                        {/**Terms & Conditions***/}
                        <AccordionItem>
                            <AccordionItemHeading>
                                <AccordionItemButton>
                                    <p>Terms & Conditions</p>
                                </AccordionItemButton>
                            </AccordionItemHeading>
                            <AccordionItemPanel>
                                <TermsConditions />
                            </AccordionItemPanel>
                        </AccordionItem>

                        {/**Neoo Search Offer Terms***/}
                        {/* <AccordionItem>
                            <AccordionItemHeading>
                                <AccordionItemButton>
                                    <p>Neoo Search Offer Terms</p>
                                </AccordionItemButton>
                            </AccordionItemHeading>
                            <AccordionItemPanel>
                                <p>
                                    Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                                    Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,
                                    when an unknown printer took a galley of type and scrambled it to make a type
                                    specimen book. It has survived not only five centuries, but also the leap into
                                    electronic typesetting, remaining essentially unchanged. It was popularised
                                    in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages,
                                    and more recently with desktop publishing software like Aldus PageMaker including
                                    versions of Lorem Ipsum.
                                </p>
                                <p>
                                    Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                                    Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,
                                    when an unknown printer took a galley of type and scrambled it to make a type
                                    specimen book. It has survived not only five centuries, but also the leap into
                                    electronic typesetting, remaining essentially unchanged. It was popularised
                                    in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages,
                                    and more recently with desktop publishing software like Aldus PageMaker including
                                    versions of Lorem Ipsum.
                                </p>
                            </AccordionItemPanel>
                        </AccordionItem> */}
                    </Accordion>
                    {/****accordion end***/}

                </div>
            </section>
        </>
    )
}

export default RewardsAbout